/**
 * Notification popup.
 *
 * Call it through the shared service Notify.
 */
angular.module('hjApp').directive('notification', [
    '$rootScope',
    '$timeout',
    'SessionStorage',
    function ($rootScope, $timeout, SessionStorage) {
        var hidePromise;

        return {
            restrict: 'E',
            replace: true,
            scope: {},
            template:
                '<div class="notification-box {{ boxClass }}">' +
                '<div class="close hidden" ng-click="hideCentralNotification()">&times;</div>' +
                '<div class="notification-box-content {{ contentClass }}">' +
                '<ng-bind-html ng-bind-html="message"> </ng-bind-html>' +
                '</div></div>',
            link: function (scope) {
                var storedHjNotification, storedHjCentralNotification;

                // Show the notification immediately when the hjNotification signal is emitted.
                const notificationCallback = function (event, notification) {
                    $rootScope.$applyAsync(() => {
                        scope.boxClass = 'notification-box-visible';
                        scope.contentClass = notification.cls;
                        scope.message = notification.message;
                    });

                    if (hidePromise) {
                        $timeout.cancel(hidePromise);
                    }

                    hidePromise = $timeout(function () {
                        $rootScope.$applyAsync(() => {
                            scope.boxClass = '';
                            hidePromise = null;
                        });
                    }, notification.timeout);
                };

                $rootScope.$on('hjNotification', notificationCallback);
                window.addEventListener('hjNotification', (e) => notificationCallback(e, e.detail));

                // Show the central notification immediately when the hjCentralNotification signal is emitted.
                $rootScope.$on('hjCentralNotification', function (event, notification) {
                    scope.boxClass = 'notification-box-central notification-box-visible';
                    scope.contentClass = notification.cls;
                    scope.message = notification.message;
                });

                $rootScope.$on('hjHideNotification', function () {
                    scope.boxClass = '';
                    hidePromise = null;
                });

                // Check if we have a notification we should display which was created before the page reload.
                storedHjNotification = SessionStorage.get('hjNotification');
                storedHjCentralNotification = SessionStorage.get('hjCentralNotification');

                if (storedHjNotification) {
                    SessionStorage.remove('hjNotification');
                    $rootScope.$emit('hjNotification', storedHjNotification);
                }

                if (storedHjCentralNotification) {
                    SessionStorage.remove('hjCentralNotification');
                    $rootScope.$emit('hjCentralNotification', storedHjCentralNotification);
                }

                // Hide the central popup. We leave the central class to not shift the position until it fades out.
                scope.hideCentralNotification = function () {
                    scope.boxClass = 'notification-box-central';
                };
            }
        };
    }
]);
